export default __webpack_public_path__ + "static/media/draw2-sound.0f5186fc.mp3";